import "core-js/modules/es.array.concat.js";
import noNetTip from "../components/NoNetTip";
import { getSleepStatisticsDataApi, getUserInfo, getVipFlag } from "../../utils/api";
import moment from "moment";
import { eventTracking } from "../../utils/native";
import { goToOpenVipPage, secondsToHourAndMinutes } from "../../utils/utils";
export default {
  name: "index",
  data: function data() {
    return {
      oversea: true,
      isloading: false,
      noNet: false,
      avatar: require("../../assets/imgs/icon_avatar.png"),
      flag: '',
      cn_img: require("../../assets/imgs/cn.png"),
      global_img: require("../../assets/imgs/earth.png"),
      tag_img1: require("../../assets/imgs/sleep_tag1.png"),
      tag_img2: require("../../assets/imgs/sleep_tag2.png"),
      tag_img3: require("../../assets/imgs/sleep_tag3.png"),
      imgVip: require("../../assets/imgs/vip.png"),
      detail: {},
      sleepTime: "--".concat(this.$t('message.sleep.hour'), " --").concat(this.$t('message.sleep.minute'))
    };
  },
  components: {
    noNetTip: noNetTip
  },
  computed: {},
  watch: {
    '$route': {
      handler: function handler(route) {
        this.getDateByRoute(route);
        this.query = route.query;
        this.queryIsVip();
        this.getUserInfos();
      },
      immediate: true
    }
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.sleep.sleepCompare"); // 标题国际化
  },
  created: function created() {
    this.oversea = localStorage.getItem('oversea') == '1';
    this.getDateByRoute(this.$route); // 埋点

    eventTracking('sleep_compare_page', 'page_show');
  },
  methods: {
    // 通过路由获取选中模式和日期
    getDateByRoute: function getDateByRoute(route) {
      var _this = this;

      var _ref = route.params || {},
          year = _ref.year,
          month = _ref.month,
          day = _ref.day;

      this.year = year || moment().year();
      this.month = month || moment().month() + 1;
      this.day = day || moment().date();
      this.isloading = true;
      getSleepStatisticsDataApi({
        year: this.year,
        month: this.month,
        day: this.day
      }).then(function (res) {
        _this.isloading = false;

        if (res) {
          _this.detail = res;
        } // console.log(res)

      }).catch(function (err) {
        _this.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this.noNet = true;
        }
      });
    },
    getUserInfos: function getUserInfos() {
      var _this2 = this;

      // console.log(this.query)
      getUserInfo().then(function (res) {
        _this2.avatar = res && res.headImageUrl ? res.headImageUrl : require("../../assets/imgs/icon_avatar.png"); // console.log(res)
      });
    },
    // 请求是否为会员
    queryIsVip: function queryIsVip() {
      var _this3 = this;

      getVipFlag().then(function (res) {
        // console.log('getVipFlag', res)
        _this3.flag = res.vipFlag;
        _this3.date = res.vaildDate;
      });
    },
    // 跳转开通会员页面
    goOpenVipPage: function goOpenVipPage() {
      // 埋点
      eventTracking('sleep_compare_page', 'app_sleep_vip_click', {
        button_type: 'open'
      });
      goToOpenVipPage();
    },
    transferSeconds: function transferSeconds(value) {
      var result = secondsToHourAndMinutes(value);
      return result.hour ? "".concat(result.hour).concat(this.$t('message.sleep.hour'), " ").concat(result.minute).concat(this.$t('message.sleep.minute')) : "".concat(result.minute).concat(this.$t('message.sleep.minute'));
    },
    transferSecondsToTime: function transferSecondsToTime(value) {
      return moment(value).format('HH:mm');
    }
  }
};